import { useCallback } from "react";
var useScrollToRef = function useScrollToRef() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scrollToRef = useCallback(function (ref) {
    if (ref !== null && ref !== void 0 && ref.current) {
      ref.current.scrollIntoView({
        behavior: options.behavior || 'smooth',
        // "smooth" or "auto"
        block: options.block || 'start',
        // "start", "center", "end", "nearest"
        inline: options.inline || 'nearest' // Used for horizontal scrolling
      });
    }
  }, [options]);
  return scrollToRef;
};
export default useScrollToRef;